import { ECountryCode } from "@/domains/country/country.types.ts";

const country: Record<ECountryCode, string> = {
  [ECountryCode.FRANCE]: "France",
  [ECountryCode.BELGIUM]: "Belgique",
  [ECountryCode.FINLAND]: "Finlande",
  [ECountryCode.SLOVENIA]: "Slovénie",
  [ECountryCode.SWEDEN]: "Suède",
  [ECountryCode.GREAT_BRITAIN]: "Royaume-Uni",
  [ECountryCode.SPAIN]: "Espagne",
  [ECountryCode.CZECH]: "République Tchèque",
  [ECountryCode.HUNGARY]: "Hongrie",
};

export type CountryLocale = typeof country;

export default {
  country,
};
